import { render, staticRenderFns } from "./OrderListTab.vue?vue&type=template&id=5f878919&scoped=true"
import script from "./OrderListTab.vue?vue&type=script&lang=js"
export * from "./OrderListTab.vue?vue&type=script&lang=js"
import style0 from "./OrderListTab.vue?vue&type=style&index=0&id=5f878919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f878919",
  null
  
)

export default component.exports